import { init } from "@marko/runtime-tags/dom";
import "./projects.marko";
import "../../src/routes/+layout.marko";
import "../../src/tags/app-header/index.marko";
import "../../src/tags/app-footer/index.marko";
import "../../src/tags/project-grid/index.marko";
import "../../src/tags/project-card/index.marko";
import "../../src/tags/app-header/index.marko";
import "../../src/tags/app-footer/index.marko";
import "../../src/tags/project-grid/index.marko";
import "../../src/tags/project-card/index.marko";
export default () => init();